import React from 'react';
import { Clock, Award, FileText, Calendar } from 'lucide-react';

const Evaluation = ({ evaluationData, applicationData }) => {

    return (
        <div className="space-y-4 sm:space-y-6">
            {/* Header */}
            <div className="text-center">
                <Award className="w-8 h-8 sm:w-12 sm:h-12 text-custom-blue-1 mx-auto mb-3 sm:mb-4" />
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">Application Evaluation</h2>
                <p className="text-gray-600 text-sm sm:text-base">Review of your hackathon application</p>
            </div>

            {/* Evaluation Details */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                <div className="bg-gray-50 px-3 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <FileText className="w-4 h-4 sm:w-5 sm:h-5" />
                        Evaluation Details
                    </h3>
                </div>

                <div className="p-3 sm:p-6 space-y-4 sm:space-y-6">
                    {/* Evaluator Information */}
                    {evaluationData?.evaluator && (
                        <div>
                            <h4 className="font-semibold text-gray-700 mb-2 text-sm sm:text-base">Evaluator</h4>
                            <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
                                <p className="text-gray-700 text-sm sm:text-base">
                                    Evaluated by: <span className="font-medium">{evaluationData.evaluator}</span>
                                </p>
                                {evaluationData?.evaluatedAt && (
                                    <p className="text-gray-600 text-xs sm:text-sm mt-1">
                                        on {new Date(evaluationData.evaluatedAt.toDate()).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Evaluator Comments */}
                    {evaluationData?.feedback && (
                        <div>
                            <h4 className="font-semibold text-gray-700 mb-2 text-sm sm:text-base">Evaluator Feedback</h4>
                            <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
                                <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                                    {evaluationData.feedback}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Application Summary */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                <div className="bg-gray-50 px-3 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 flex items-center gap-2">
                        <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
                        Application Summary
                    </h3>
                </div>

                <div className="p-3 sm:p-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                        <div>
                            <h4 className="font-semibold text-gray-700 mb-2 text-sm sm:text-base">Team Information</h4>
                            <div className="space-y-1 text-xs sm:text-sm text-gray-600">
                                <p><span className="font-medium">Team Name:</span> {applicationData.teamName}</p>
                                <p><span className="font-medium">Team Size:</span> {applicationData.teamSize}</p>
                                <p><span className="font-medium">Leader:</span> {applicationData.teamLeaderName}</p>
                            </div>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-700 mb-2 text-sm sm:text-base">Contact Information</h4>
                            <div className="space-y-1 text-xs sm:text-sm text-gray-600">
                                <p><span className="font-medium">Email:</span> {applicationData.teamLeaderEmail}</p>
                                <p><span className="font-medium">Phone:</span> {applicationData.teamLeaderPhone}</p>
                                {applicationData.timeCommitment && (
                                    <p><span className="font-medium">Time Commitment:</span> {applicationData.timeCommitment}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Evaluation;
